import React from "react";
import UserApprovalRow from "./user-approval-Row";
import * as requisitionTypes from "../../../../general/paper-state";
import { connect } from "react-redux";

class UserApprovalsTable extends React.Component {
  rowsIfPaperIsApproved = () => {
    // if paper is approved whe take the data from approvals list
    return this.props.approvals.map((approval, i) => {
      return (
        <UserApprovalRow
          key={approval.id}
          index={i}
          date={approval.date}
          email={approval.email}
          orderNumber={i}
          firstName={approval.firstName}
          lastName={approval.lastName}
          approved={approval.approved}
          canApprove={false}
          calling={approval.calling}
          paperId={this.props.paperId}
          paper={this.props.paper}
          onReject={this.props.onReject}
          onApprove={this.props.onApprove}
          showApprovingProgress={this.props.showApprovingProgress}
          allApproved={requisitionTypes.isApproved(this.props.state)}
        />
      );
    });
  };

  rowsIfPaperIsNotApproved = () => {
    const rows = [];

    const ordersApproved = this.props.approvals.map(
      (approval) => approval.orderNumber
    );

    // First rendered approvals
    this.props.approvals.forEach((approval, i) => {
      rows.push(
        <UserApprovalRow
          key={approval.id}
          index={i}
          date={approval.date}
          email={approval.email}
          orderNumber={i}
          firstName={approval.firstName}
          lastName={approval.lastName}
          approved={approval.approved}
          canApprove={false}
          calling={approval.calling}
          paperId={this.props.paperId}
          paper={this.props.paper}
          onReject={this.props.onReject}
          onApprove={this.props.onApprove}
          showApprovingProgress={this.props.showApprovingProgress}
          allApproved={requisitionTypes.isApproved(this.props.state)}
        />
      );
    });

    // After render the rest of the steps that are not approved
    this.props.steps.map((step, i) => {
      if (!ordersApproved.includes(step.stepOrder)) {
        let approved = null;

        let date = null;

        let isDelegated =
          step.delegatedSignedBy !== null &&
          step.delegatedSignedBy.email === this.props.userEmail;
        let canApprove =
          (step.signedBy.email === this.props.userEmail || isDelegated) &&
          this.props.canApprove;

        let firstName = isDelegated
          ? step.delegatedSignedBy.firstName
          : step.signedBy.firstName;
        let lastName = isDelegated
          ? step.delegatedSignedBy.lastName
          : step.signedBy.lastName;
        let email = isDelegated
          ? step.delegatedSignedBy.email
          : step.signedBy.email;

        rows.push(
          <UserApprovalRow
            key={step.id}
            index={i}
            date={date}
            email={email}
            orderNumber={step.stepOrder}
            firstName={firstName}
            lastName={lastName}
            approved={approved}
            canApprove={canApprove}
            calling={step.calling}
            paperId={this.props.paperId}
            paper={this.props.paper}
            onReject={this.props.onReject}
            onApprove={this.props.onApprove}
            showApprovingProgress={this.props.showApprovingProgress}
            allApproved={requisitionTypes.isApproved(this.props.state)}
          />
        );
      }
    });

    return rows;
  };

  render() {
    let rows = [];

    if (requisitionTypes.isApproved(this.props.state)) {
      rows = this.rowsIfPaperIsApproved();
    } else {
      rows = this.rowsIfPaperIsNotApproved();
    }

    return (
      <div>
        <div className="ds-table-card ds-table-card--flat"><table className="table table-hover">
          <tbody>
            <tr>
              <th />
              <th>Nume</th>
              <th>Prenume</th>
              <th>Email</th>
              <th>Stare aprobare</th>
              <th>Data</th>
            </tr>
            {rows}
          </tbody>
        </table></div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userEmail: state.login.user.email,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserApprovalsTable);
